import { Card as AntdCard, type CardProps } from 'antd';

const Card = (props: CardProps) => {
  return <AntdCard {...props} />;
};

export default Card;
